// utils/storage.js
import localForage from 'localforage';

export const getLocalStorageTimestamp = () => {
    return localStorage.getItem('localStorageTimestamp');
};

export const setLocalStorageTimestamp = () => {
    const now = new Date().getTime();
    localStorage.setItem('localStorageTimestamp', now);
};

export const clearStorageIfExpired = async () => {
    const timestamp = getLocalStorageTimestamp();
    const now = new Date().getTime();
    const twentyFourHours = 24 * 60 * 60 * 1000; // 24 horas

    if (timestamp && now - timestamp > twentyFourHours) {
        console.log('⚠️ localStorage expirado (>24 horas). Limpiando carrito...');
        
        // Limpiar localStorage
        localStorage.clear();
        
        // Limpiar localForage (donde está el carrito con key '@session')
        try {
            await localForage.clear();
            console.log('✅ Carrito limpiado de localForage/IndexedDB');
        } catch (error) {
            console.error('Error limpiando localForage:', error);
        }
        
        setLocalStorageTimestamp(); // Reset the timestamp after clearing storage
    }
};
